<td class>
    <select class="form-select float-left width-120" aria-label="Status select" [(ngModel)]="currentStatus">
    <option *ngFor="let pistatus of inputList" value="{{pistatus}}" [selected]="pistatus == currentStatus">{{ pistatus }}</option>
    </select>
    <button class="btn btn-color" (click)="getStatus()" title="save"><i class="bi bi-check-circle"></i></button>
</td>